import { faker } from '@faker-js/faker';

import type { ChangeMonthlyPaymentPostResponse } from '../types/ChangeMonthlyPaymentPostResponse';

export function createChangeMonthlyPaymentPostResponse(
  data: NonNullable<Partial<ChangeMonthlyPaymentPostResponse>> = {}
): NonNullable<ChangeMonthlyPaymentPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
